import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { actionListUsers } from "../usuarios-list/slices";
import { toggleUserStatus } from "./services";

interface IStateStatusUsuario {
  statusToggle: "" | "success" | "failed" | "loading";
  feedbackError: string;
}

export const actionToggleUserStatus = createAsyncThunk(
  "USUARIO/TOGGLE_STATUS",
  async ({ id, ativo }: { id: number; ativo: boolean }, { dispatch }) => {
    const response = await toggleUserStatus(id, ativo);

    dispatch(actionListUsers());

    return response;
  },
);

const usuarioStatusSlice = createSlice({
  name: "usuarioStatus",
  initialState: <IStateStatusUsuario>{
    statusToggle: "",
    feedbackError: "",
  },
  reducers: {
    actionResetStatus: (state) => {
      state.statusToggle = "";
      state.feedbackError = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionToggleUserStatus.pending, (state) => {
        state.statusToggle = "loading";
      })
      .addCase(actionToggleUserStatus.fulfilled, (state) => {
        state.statusToggle = "success";
      })
      .addCase(actionToggleUserStatus.rejected, (state, action) => {
        state.statusToggle = "failed";
        state.feedbackError = action.error.message || "Erro ao alterar status";
      });
  },
});

export const { actionResetStatus } = usuarioStatusSlice.actions;
export default usuarioStatusSlice.reducer;
